export const ThankfulLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <g
      id="Thankful_Badge_-_Locked"
      data-name="Thankful Badge - Locked"
      transform="translate(1 -5)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          fill="transparent"
          stroke="#666"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <g id="SJ-Icon-B_Donate_Red_RGB" transform="translate(9.612 7.729)">
          <path
            id="Path_2211"
            data-name="Path 2211"
            d="M16.718,47.468H1.709a.7.7,0,0,1,0-1.406H16.718a7.686,7.686,0,0,0,5.47-2.265l6.284-6.284a1.336,1.336,0,0,0-1.748-.312l-7.134,4.37a3.534,3.534,0,0,1-2.746.4L11.43,40.519a1.172,1.172,0,0,1-.049-2.25l5.685-1.792a1.059,1.059,0,0,0,.7-1.307H10.706a6.836,6.836,0,0,0-4.14,1.406l-4.429,3.4a.7.7,0,1,1-.856-1.115l4.429-3.4a8.248,8.248,0,0,1,5-1.7h7.221A1.176,1.176,0,0,1,19,34.457a2.465,2.465,0,0,1-1.507,3.362l-4.919,1.55,4.637,1.242a2.114,2.114,0,0,0,1.648-.239L25.989,36a2.743,2.743,0,0,1,3.8.956,1.167,1.167,0,0,1-.186,1.411l-6.423,6.423A9.082,9.082,0,0,1,16.718,47.468Z"
            transform="translate(0 -17.409)"
            fill="#666"
          />
          <path
            id="Path_2212"
            data-name="Path 2212"
            d="M22.613,15.417a.7.7,0,0,1-.437-.152l-.06-.047c-.935-.731-2.686-2.111-3.915-3.14-2.443-2.046-3.78-4.092-3.867-5.917a5.055,5.055,0,0,1,1.181-3.539A4.6,4.6,0,0,1,18.834,1a4.836,4.836,0,0,1,3.778,1.551A4.845,4.845,0,0,1,26.388,1a4.608,4.608,0,0,1,3.321,1.623,5.051,5.051,0,0,1,1.18,3.538c-.086,1.826-1.423,3.872-3.867,5.917-1.553,1.3-3.955,3.174-3.978,3.192A.7.7,0,0,1,22.613,15.417ZM19.062,2.4c-.054,0-.107,0-.162,0a3.211,3.211,0,0,0-2.317,1.132A3.653,3.653,0,0,0,15.738,6.1C15.805,7.5,17,9.239,19.1,11c1.067.893,2.539,2.06,3.509,2.821.761-.6,2.367-1.867,3.507-2.821,2.1-1.761,3.3-3.5,3.365-4.9a3.651,3.651,0,0,0-.845-2.559A3.215,3.215,0,0,0,26.322,2.4h0a3.465,3.465,0,0,0-3.108,1.672.7.7,0,0,1-.6.338h0a.7.7,0,0,1-.6-.338A3.463,3.463,0,0,0,19.062,2.4Z"
            transform="translate(-7.077 0)"
            fill="#666"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ThankfulUnlocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="55"
    viewBox="0 0 50 55"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="Thankful_Badge_-_Unlocked"
      data-name="Thankful Badge - Unlocked"
      transform="translate(1)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          stroke="#8d0034"
          strokeLinecap="round"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
        <g id="SJ-Icon-B_Donate_Red_RGB" transform="translate(9.612 7.729)">
          <path
            id="Path_2211"
            data-name="Path 2211"
            d="M16.718,47.468H1.709a.7.7,0,0,1,0-1.406H16.718a7.686,7.686,0,0,0,5.47-2.265l6.284-6.284a1.336,1.336,0,0,0-1.748-.312l-7.134,4.37a3.534,3.534,0,0,1-2.746.4L11.43,40.519a1.172,1.172,0,0,1-.049-2.25l5.685-1.792a1.059,1.059,0,0,0,.7-1.307H10.706a6.836,6.836,0,0,0-4.14,1.406l-4.429,3.4a.7.7,0,1,1-.856-1.115l4.429-3.4a8.248,8.248,0,0,1,5-1.7h7.221A1.176,1.176,0,0,1,19,34.457a2.465,2.465,0,0,1-1.507,3.362l-4.919,1.55,4.637,1.242a2.114,2.114,0,0,0,1.648-.239L25.989,36a2.743,2.743,0,0,1,3.8.956,1.167,1.167,0,0,1-.186,1.411l-6.423,6.423A9.082,9.082,0,0,1,16.718,47.468Z"
            transform="translate(0 -17.409)"
            fill="#fff"
          />
          <path
            id="Path_2212"
            data-name="Path 2212"
            d="M22.613,15.417a.7.7,0,0,1-.437-.152l-.06-.047c-.935-.731-2.686-2.111-3.915-3.14-2.443-2.046-3.78-4.092-3.867-5.917a5.055,5.055,0,0,1,1.181-3.539A4.6,4.6,0,0,1,18.834,1a4.836,4.836,0,0,1,3.778,1.551A4.845,4.845,0,0,1,26.388,1a4.608,4.608,0,0,1,3.321,1.623,5.051,5.051,0,0,1,1.18,3.538c-.086,1.826-1.423,3.872-3.867,5.917-1.553,1.3-3.955,3.174-3.978,3.192A.7.7,0,0,1,22.613,15.417ZM19.062,2.4c-.054,0-.107,0-.162,0a3.211,3.211,0,0,0-2.317,1.132A3.653,3.653,0,0,0,15.738,6.1C15.805,7.5,17,9.239,19.1,11c1.067.893,2.539,2.06,3.509,2.821.761-.6,2.367-1.867,3.507-2.821,2.1-1.761,3.3-3.5,3.365-4.9a3.651,3.651,0,0,0-.845-2.559A3.215,3.215,0,0,0,26.322,2.4h0a3.465,3.465,0,0,0-3.108,1.672.7.7,0,0,1-.6.338h0a.7.7,0,0,1-.6-.338A3.463,3.463,0,0,0,19.062,2.4Z"
            transform="translate(-7.077 0)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_2669" data-name="Group 2669" transform="translate(31)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
